import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { hlp_getContentDate } from '@app/_v3/helpers/content-helpers';
import { AccountService, BillingV2Service, MeetingsService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { LibraryRouter } from '@models/library.router';
import { IAccountStats, Meeting, MeetingTypeEnum, SubjectCategoryEnum, User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-meeting-card-half',
  templateUrl: './meeting-card-half.component.html',
  styleUrls: ['./meeting-card-half.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingCardHalfComponent extends ChangableComponent {
  private billingV2Service = inject(BillingV2Service);
  deviceService = inject(DeviceDetectorService);
  private meetingsService = inject(MeetingsService);

  @Input() public set meeting(meeting: Meeting) {
    this._meeting = meeting;
    this.prepareCard();
  }
  public get meeting() {
    return this._meeting;
  }

  public title: string;
  public fullTitle: string;
  public authorUrl: string[];
  public coverImageUrl: string;
  public metaImageUrl: string;
  public subjectTitle: string;
  public subjectIsNative: boolean;
  public typeTitle: string;
  public duration: number;
  public price_tier: number;
  public begin_at: Date;
  public userpicUrl: string;
  public userpicFullname: string;
  public authorStats: Partial<IAccountStats>;
  public meetingRoute: string;
  public description: string;
  public contentDate: Date;
  public alertOpened: boolean;

  private _meeting: Meeting;
  private _author: User;

  public onOpenCardInModal() {}
  public goSignup(e) {}

  public getFormattedPrice(amount: number, discount?: number): Observable<string> {
    return this.billingV2Service.formatAmount$(amount, discount);
  }

  private prepareCard() {
    this._author = this._meeting?.author;
    this.title = this._meeting?.title;
    this.fullTitle = this.meetingsService.meetingFullTitle(this._meeting);
    this.authorUrl = AccountService.accountRoute(this._author);
    this.description = this._meeting?.description;
    this.coverImageUrl = this.assetsUrl(this._meeting?.cover?.mdX2?.url);
    this.subjectTitle = this._meeting?.subject?.title;
    this.subjectIsNative = this._meeting?.subject?.category_id === SubjectCategoryEnum.native_language;
    this.typeTitle = this.setTitle();
    this.duration = this._meeting?.duration / 60;
    this.price_tier = this._meeting?.price_tier;
    this.begin_at = new Date(this._meeting?.begin_at);
    this.userpicUrl = this.assetsUrl(this._meeting?.author?.userpic?.smX2?.url);
    this.authorStats = this._meeting?.author?.stats;
    this.userpicFullname = AccountService.getUserFullName(this._meeting?.author);
    this.meetingRoute = LibraryRouter.meetingRoute(this._meeting).join('');
    this.contentDate = hlp_getContentDate(this._meeting?.published_at, this._meeting?.created_at);
  }

  private setTitle(): string {
    switch (this._meeting.type) {
      case MeetingTypeEnum.stream:
        return 'Стрим';
      case MeetingTypeEnum.single:
        return 'Индивидуальное занятие';
      case MeetingTypeEnum.group:
        return 'Групповое занятие';
      case MeetingTypeEnum.webinar:
        return 'Вебинар';
      default:
        return '';
    }
  }
}
